import { AbstractApi } from '../../../common/api'
import { downloadFile } from '../../../common/api/request'
import { WorkspaceExportOptions } from '../../../modules/workspace/workspace/types/wrokspace.types'

class ExcelApi extends AbstractApi {
  protected url = '/excel'

  public async exportWorkspace(configuration: WorkspaceExportOptions) {
    await downloadFile('POST', this.url.concat('/milestone-export/'), configuration)
  }
}

export const excelApi = new ExcelApi()
